import { render, staticRenderFns } from "./TableModal.vue?vue&type=template&id=3053f54b&"
import script from "./TableModal.vue?vue&type=script&lang=js&"
export * from "./TableModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports